import styles from "./index.module.css";
import { useAdsMap } from "./Chart/useAdsMap";
import StatCard from "./Card";
import {Banknote, Calculator, ConciergeBell, ConciergeBellIcon, Monitor, Mouse} from "lucide-react"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  Tooltip as ChartTooltip,
  Legend,
  PointElement
} from "chart.js";
import ReactTooltip from 'react-tooltip';
import "flatpickr/dist/themes/airbnb.css";
import { useEffect, useState} from "react"
import Flatpickr from "react-flatpickr";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import Spinner from 'react-bootstrap/Spinner';
import { CurrencyConverter } from "./Unit/CurrencyConverter";
import  useCurrencyRate  from "./Unit/useCurrencyRate";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  ChartTooltip,
  Legend,
  PointElement
);

export default function Compare() {
     const {t} = useTranslation()
     const { usdRate, timeLastUpdated } = useCurrencyRate();
    //  const [propertyID, setPropertyID] = useState("366123786")
     const [isLoading, setIsLoading] = useState(false)
     const [currency, setCurrency] = useState("VND");

     const [startDate, setStartDate] = useState(() => dayjs().startOf("month").format("YYYY-MM-DD") );
     const [endDate, setEndDate] = useState(() => dayjs().format("YYYY-MM-DD") );

     const [startDateLastMonth, setStartDateLastMonth] = useState(() => dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD") );
     const [endDateLastMonth, setEndDateLastMonth] = useState(() => dayjs().subtract(1, "month").endOf("month").format("YYYY-MM-DD") );

     const [startDateLastYear, setStartDateLastYear] = useState(() => dayjs().subtract(1, "year").startOf("year").format("YYYY-MM-DD") );
     const [endDateLastYear, setEndDateLastYear] = useState(() => dayjs().subtract(1, "year").startOf("year").format("YYYY-MM-DD") );

     const [impressions, setImpressions] = useState(0);
     const [clicks, setClicks] = useState(0);
     const [costs, setCosts] = useState(0);
     const [cpc, setCPC] = useState(0)
     const [ctr, setCTR] = useState(0)

     const [impressionsLastMonth, setImpressionsLastMonth] = useState(0);
     const [clicksLastMonth, setClicksLastMonth] = useState(0);
     const [costsLastMonth, setCostsLastMonth] = useState(0);
     const [cpcLastMonth, setCPCLastMonth] = useState(0)
     const [ctrLastMonth, setCTRLastMonth] = useState(0)

     const [impressionsLastYear, setImpressionsLastYear] = useState(0);
     const [clicksLastYear, setClicksLastYear] = useState(0);
     const [costsLastYear, setCostsLastYear] = useState(0);
     const [cpcLastYear, setCPCLastYear] = useState(0)
     const [ctrLastYear, setCTRLastYear] = useState(0)
     
     const [adsData, setAdsData] = useState([]);
     const [adsDataLastMonth, setAdsDataLastMonth] = useState([]);
     const [adsDataLastYear, setAdsDataLastYear] = useState([]);

     const [conversion, setConversion] = useState(0);
     const [conversionLastMonth, setConversionLastMonth] = useState(0);
     const [conversionLastYear, setConversionLastYear] = useState(0);
      // const [resource, setResource] = useState("20838761231");


    const fetchAdsData = async () => {
      setIsLoading(true);

      try {
        const res = await fetch(
          `/api/googleAds/ads-data/campaign/${startDate}/${endDate}`
        );
    
          if (!res.ok) {
            throw new Error('Network response was not ok');
          }
          const responseData = await res.json();
          if(responseData){
            setIsLoading(false) 
            setAdsData(responseData)
            calculateMetrics(responseData)
          }

        } catch (error) {
          console.error('Error:', error);
      }
      }
    const fetchAdsDataLastMonth = async () => {
      setIsLoading(true);

      try {
        const res = await fetch(
          `/api/googleAds/ads-data/campaign/${startDateLastMonth}/${endDateLastMonth}`
        );
    
          if (!res.ok) {
            throw new Error('Network response was not ok');
          }
          const responseData = await res.json();
          if(responseData){
            setIsLoading(false) 
            setAdsDataLastMonth(responseData)
            calculateMetricsLastMonth(responseData)
          }

        } catch (error) {
          console.error('Error:', error);
      }
      }
    const fetchAdsDataLastYear = async () => {
      setIsLoading(true);

      try {
        const res = await fetch(
          `/api/googleAds/ads-data/campaign/${startDateLastYear}/${endDateLastYear}`
        );
    
          if (!res.ok) {
            throw new Error('Network response was not ok');
          }
          const responseData = await res.json();
          if(responseData){
            setIsLoading(false) 
            setAdsDataLastYear(responseData)
            calculateMetricsLastYear(responseData)
          }

        } catch (error) {
          console.error('Error:', error);
      }
      }

    const fetchAdsConversionData = async () => {
      setIsLoading(true);

      try {
        const res = await fetch(
          `/api/googleAds/ads-conversions/${startDate}/${endDate}`
        );
    
          if (!res.ok) {
            throw new Error('Network response was not ok');
          }
          const responseData = await res.json();
          if(responseData){
            setIsLoading(false) 
            const total = Object.entries(responseData)
            // .filter(([key]) => !key.includes("Phnom Penh"))
            .reduce((sum, [, value]) => sum + Number(value), 0);

            setConversion(total)
          }

        } catch (error) {
          console.error('Error:', error);
      }
      }
    const fetchAdsConversionDataLastMonth = async () => {
      setIsLoading(true);

      try {
        const res = await fetch(
          `/api/googleAds/ads-conversions/${startDateLastMonth}/${endDateLastMonth}`
        );
    
          if (!res.ok) {
            throw new Error('Network response was not ok');
          }
          const responseData = await res.json();
          if(responseData){
            setIsLoading(false) 
            const total = Object.entries(responseData)
            // .filter(([key]) => !key.includes("Phnom Penh"))
            .reduce((sum, [, value]) => sum + Number(value), 0);

            setConversionLastMonth(total)
          }

        } catch (error) {
          console.error('Error:', error);
      }
      }
    const fetchAdsConversionDataLastYear = async () => {
      setIsLoading(true);

      try {
        const res = await fetch(
          `/api/googleAds/ads-conversions/${startDateLastYear}/${endDateLastYear}`
        );
    
          if (!res.ok) {
            throw new Error('Network response was not ok');
          }
          const responseData = await res.json();
          if(responseData){
            setIsLoading(false) 
            const total = Object.entries(responseData)
            // .filter(([key]) => !key.includes("Phnom Penh"))
            .reduce((sum, [, value]) => sum + Number(value), 0);

            setConversionLastYear(total)
          }

        } catch (error) {
          console.error('Error:', error);
      }
      }

    const calculateMetrics = (data) => {
      if (!data?.length) return;

        let impressions = 0;
        let clicks = 0;
        let cost = 0;

        for (const row of data) {
          impressions += Number(row.metrics?.impressions || 0);
          clicks += Number(row.metrics?.clicks || 0);
          cost += Number(row.metrics?.costMicros || 0);
        }

        cost = cost / 1_000_000; 
        cost = CurrencyConverter(cost, currency, usdRate)
         
        const ctr = impressions > 0 ? (clicks / impressions) * 100 : 0;
        const cpc = clicks > 0 ? cost / clicks : 0;

        setImpressions(impressions);
        setClicks(clicks);
        setCosts(cost);
        setCTR(ctr);
        setCPC(cpc);
      }
    const calculateMetricsLastMonth = (data) => {
      if (!data?.length) return;

        let impressionsLastMonth = 0;
        let clicksLastMonth = 0;
        let costLastMonth = 0;

        for (const row of data) {
          impressionsLastMonth += Number(row.metrics?.impressions || 0);
          clicksLastMonth += Number(row.metrics?.clicks || 0);
          costLastMonth += Number(row.metrics?.costMicros || 0);
        }

        costLastMonth = costLastMonth / 1_000_000; 
        costLastMonth = CurrencyConverter(costLastMonth, currency, usdRate )
        
        const ctrLastMonth = impressionsLastMonth > 0 ? (clicksLastMonth / impressionsLastMonth) * 100 : 0;
        const cpcLastMonth = clicksLastMonth > 0 ? costLastMonth / clicksLastMonth : 0;

        setImpressionsLastMonth(impressionsLastMonth);
        setClicksLastMonth(clicksLastMonth);
        setCostsLastMonth(costLastMonth);
        setCTRLastMonth(ctrLastMonth);
        setCPCLastMonth(cpcLastMonth);
      }
    const calculateMetricsLastYear = (data) => {
      if (!data?.length) return;

        let impressionsLastYear = 0;
        let clicksLastYear = 0;
        let costLastYear = 0;

        for (const row of data) {
          impressionsLastYear += Number(row.metrics?.impressions || 0);
          clicksLastYear += Number(row.metrics?.clicks || 0);
          costLastYear  += Number(row.metrics?.costMicros || 0);
        }

        costLastYear = costLastYear / 1_000_000; 
        costLastYear = CurrencyConverter(costLastYear, currency, usdRate) 
        
        const ctrLastYear = impressionsLastYear > 0 ? (clicksLastYear / impressionsLastYear) * 100 : 0;
        const cpcLastYear = clicksLastYear > 0 ? costLastYear / clicksLastYear : 0;

        setImpressionsLastYear(impressionsLastYear);
        setClicksLastYear(clicksLastYear);
        setCostsLastYear(costLastYear);
        setCTRLastYear(ctrLastYear);
        setCPCLastYear(cpcLastYear);
      }


    //  const CurrencyConverter = (amount, currency) =>  {
    //   return currency === "USD"
    //     ? amount / 25500
    //     : amount;
    // };

    return (
      <>
   <div style={{ background: '#fff', color: '#222' }}> 
     <div style={{ padding: 30, backgroundColor:"#fff" }}></div>
           </div>
      {isLoading && (
            <div style={{
              height: '100vh', 
              width: '100vw',  
              position: 'fixed', 
              top: 0,           
              left: 0,          
              backgroundColor: 'rgba(0,0,0,0.3)', 
              zIndex: 1000,     
              display: 'flex',  
              justifyContent: 'center',
              alignItems: 'center',
            }}>
              <Spinner animation="border" role="status" style={{color: "#482979"}}></Spinner>
            </div>
          )}
        <div style={{fontSize: 60, fontWeight: 'bold'}}>Google Ads Compare Data</div>
          <div className="d-flex justify-content-center align-items-center" style={{ gap: 15, background: "#fff", padding: "12px 20px", borderRadius: 16, boxShadow: "0 2px 12px rgba(0,0,0,0.08)", width: "fit-content", margin: "20px auto" }} >
            <div style={{ fontSize: 18, fontWeight: 600, color: "#333" }}>Currency</div>

            {/* VND */}
            <label htmlFor="vnd" style={{ display: "flex", alignItems: "center", cursor: "pointer", marginRight: 0, background: currency === "VND" ? "#482979" : "#f5f5f5", color: currency === "VND" ? "#fff" : "#333", padding: "8px 14px", borderRadius: 12, fontWeight: 600, transition: "0.2s" }} >
              <input
                type="radio"
                id="vnd"
                value="VND"
                checked={currency === "VND"}
                onChange={(e) =>
                  setCurrency(e.target.value)
                }
                style={{ display: "none" }}
              />
              ₫ VND
            </label>
            {/* {(
              adsData?.length > 0 ||
              adsDataLastMonth?.length > 0 ||
              adsDataLastYear?.length > 0
            ) &&  ( */}
            <label htmlFor="usd" style={{ display: "flex", alignItems: "center", cursor: "pointer", marginLeft: 0, background: currency === "USD" ? "#482979" : "#f5f5f5", color: currency === "USD" ? "#fff" : "#333", padding: "8px 14px", borderRadius: 12, fontWeight: 600, transition: "0.2s" }} >
              <input
                type="radio"
                id="usd"
                value="USD"
                checked={currency === "USD"}
                onChange={(e) =>
                  setCurrency(e.target.value)
                }
                style={{ display: "none" }}
              />
              $ USD
            </label>
            {/* )} */}

          </div>
            <div style={{fontSize: 20, fontWeight: 'bold',color: "#482979"}}>Rate: 1$ = {Intl.NumberFormat("de-DE", { style: "currency", currency: "VND" }).format(usdRate)}</div>
            <div style={{fontSize: 15, fontWeight: 'bold',color: "#000"}}>Last Updated: {new Date(timeLastUpdated).toLocaleString()}</div>
          <div className="container-fluid mt-4">
            <div className="row">
              <div className="col-md-4">
                <div style={{ background: "#fff", borderRadius: 20, padding: 25, boxShadow: "0 4px 20px rgba(0,0,0,0.08)", border: "1px solid #eee" }} >
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }} >
                    <div>
                       <div style={{backgroundColor:"#fff" }}>
                              <div style={{width: 'fit-content'}}>
                                    <Flatpickr 
                                      value={startDate}
                                        options={{
                                        dateFormat:'Y-m-d'}} 
                                          className={`col-md-12 m-0 mb-1 ${styles.contentBookingDate} webkit-appearance`} 
                                          placeholder={t('booking.date_in')} 
                                          onChange={(dates)=>{
                                          setStartDate(dayjs(dates[0]).format("YYYY-MM-DD"));
                                        }} />
                              </div>
                              <div style={{width: 'fit-content'}}>
                                      <Flatpickr 
                                              value={endDate}
                                              options={{
                                                dateFormat:'Y-m-d'}} 
                                              className={`col-md-12 m-0 ${styles.contentBookingDate} webkit-appearance`} 
                                              placeholder={t('booking.date_out')} 
                                              onChange={(dates) =>{
                                                setEndDate(dayjs(dates[0]).format("YYYY-MM-DD"));
                                              }} />
                            
                              </div> 
                           </div>
                      </div>
                      <div 
                      style={{background: "#482979",borderRadius: 12, color: '#fff', height: 100, width: 100, fontSize: 16, fontWeight: 'bold', textAlign: 'center', lineHeight: '100px', cursor: 'pointer'}}
                      onClick={() => {
                                  if(startDate && endDate){
                                    fetchAdsData()
                                    fetchAdsConversionData()
                                  }}}
                        >
                        Get Data
                        </div>
                        
                               
                         
                        </div>

                  <div style={{ display: "flex", flexDirection: "column", gap: 14 }} >
                    {[
                      {
                        label: "Conversion",
                        value: Intl.NumberFormat("de-DE", { maximumFractionDigits: 0 }).format(conversion)
                      },
                      {
                        label: "Impressions",
                        value: Intl.NumberFormat("de-DE").format(impressions)
                      },
                      {
                        label: "Clicks",
                        value: Intl.NumberFormat("de-DE").format(clicks)
                      },
                      {
                        label: "Cost",
                        value: Intl.NumberFormat("de-DE", { style: "currency", currency: currency }).format(CurrencyConverter(costs, currency, usdRate))},
                       {
                        label: "CTR",
                        value: Intl.NumberFormat("de-DE", { style: "percent", minimumFractionDigits: 2 }).format(ctr / 100)},
                      {
                        label: "CPC",
                        value: Intl.NumberFormat("de-DE", { style: "currency", currency: currency }).format(CurrencyConverter(cpc, currency , usdRate))},
                       {
                        label: "CVR",
                        value: Intl.NumberFormat("de-DE", { style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( clicks > 0 ? (conversion / clicks) : 0 )},
                      {
                        label: "CPA",
                        value: Intl.NumberFormat("de-DE", { style: "currency", currency: currency, maximumFractionDigits: 0 }).format( conversion > 0 ? costs / conversion : 0 ) }
                    ].map((item, index) => (
                      <div key={index} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: 10, borderBottom: "1px solid #f1f1f1" }} >
                        <div style={{ color: "#777", fontSize: 25 }} > {item.label} </div>
                        <div style={{ fontWeight: "bold", fontSize: 30, color: "#222" }} >
                          {item.value}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div style={{marginTop: 10, fontSize: 30, fontWeight: 'bold'}}>{dayjs(startDate).format("MMM-YYYY")}</div>
                </div>
              </div>
                <div className="col-md-4">
                <div style={{ background: "#fff", borderRadius: 20, padding: 25, boxShadow: "0 4px 20px rgba(0,0,0,0.08)", border: "1px solid #eee" }} >
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }} >
                    <div>
                       <div style={{backgroundColor:"#fff" }}>
                              <div style={{width: 'fit-content'}}>
                                    <Flatpickr 
                                      value={startDateLastMonth}
                                        options={{
                                        dateFormat:'Y-m-d'}} 
                                          className={`col-md-12 m-0 mb-1 ${styles.contentBookingDate} webkit-appearance`} 
                                          placeholder={t('booking.date_in')} 
                                          onChange={(dates)=>{
                                          setStartDateLastMonth(dayjs(dates[0]).format("YYYY-MM-DD"));
                                        }} />
                              </div>
                              <div style={{width: 'fit-content'}}>
                                      <Flatpickr 
                                              value={endDateLastMonth}
                                              options={{
                                                dateFormat:'Y-m-d'}} 
                                              className={`col-md-12 m-0 ${styles.contentBookingDate} webkit-appearance`} 
                                              placeholder={t('booking.date_out')} 
                                              onChange={(dates) =>{
                                                setEndDateLastMonth(dayjs(dates[0]).format("YYYY-MM-DD"));
                                              }} />
                            
                              </div> 
                           </div>
                      </div>
                      <div 
                      style={{background: "#482979",borderRadius: 12, color: '#fff', height: 100, width: 100, fontSize: 16, fontWeight: 'bold', textAlign: 'center', lineHeight: '100px', cursor: 'pointer'}}
                      onClick={() => {
                                  if(startDateLastMonth && endDateLastMonth){
                                    fetchAdsDataLastMonth()
                                    fetchAdsConversionDataLastMonth()
                                  }}}
                        >
                        Get Data
                        </div>
                        </div>

                  <div style={{ display: "flex", flexDirection: "column", gap: 14 }} >
                    {[
                      {
                        label: "Conversion",
                        value: Intl.NumberFormat("de-DE", { maximumFractionDigits: 0 }).format(conversionLastMonth)
                      },
                      {
                        label: "Impressions",
                        value: Intl.NumberFormat("de-DE").format(impressionsLastMonth)
                      },
                      {
                        label: "Clicks",
                        value: Intl.NumberFormat("de-DE").format(clicksLastMonth)
                      },
                      {
                        label: "Cost",
                        value: Intl.NumberFormat("de-DE", { style: "currency", currency: currency }).format(CurrencyConverter(costsLastMonth, currency, usdRate))},
                      {
                        label: "CTR",
                        value: Intl.NumberFormat("de-DE", { style: "percent", minimumFractionDigits: 2 }).format(ctrLastMonth / 100)},
                      {
                        label: "CPC",
                        value: Intl.NumberFormat("de-DE", { style: "currency", currency: currency }).format(CurrencyConverter(cpcLastMonth, currency, usdRate) )},
                      {
                        label: "CVR",
                        value: Intl.NumberFormat("de-DE", { style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( clicksLastMonth > 0 ? (conversionLastMonth / clicksLastMonth) : 0 )},
                      {
                        label: "CPA",
                        value: Intl.NumberFormat("de-DE", { style: "currency", currency: currency, maximumFractionDigits: 0 }).format( conversionLastMonth > 0 ? costsLastMonth / conversionLastMonth : 0 ) }
                    ].map((item, index) => (
                      <div key={index} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: 10, borderBottom: "1px solid #f1f1f1" }} >
                        <div style={{ color: "#777", fontSize: 25 }} > {item.label} </div>
                        <div style={{ fontWeight: "bold", fontSize: 30, color: "#222" }} >
                          {item.value}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div style={{marginTop: 10, fontSize: 30, fontWeight: 'bold'}}>{dayjs(startDateLastMonth).format("MMM-YYYY")}</div>
                </div>
              </div>
              <div className="col-md-4">
                <div style={{ background: "#fff", borderRadius: 20, padding: 25, boxShadow: "0 4px 20px rgba(0,0,0,0.08)", border: "1px solid #eee" }} >
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }} >
                    <div>
                       <div style={{backgroundColor:"#fff" }}>
                              <div style={{width: 'fit-content'}}>
                                    <Flatpickr 
                                      value={startDateLastYear}
                                        options={{
                                        dateFormat:'Y-m-d'}} 
                                          className={`col-md-12 m-0 mb-1 ${styles.contentBookingDate} webkit-appearance`} 
                                          placeholder={t('booking.date_in')} 
                                          onChange={(dates)=>{
                                          setStartDateLastYear(dayjs(dates[0]).format("YYYY-MM-DD"));
                                        }} />
                              </div>
                              <div style={{width: 'fit-content'}}>
                                      <Flatpickr 
                                              value={endDateLastYear}
                                              options={{
                                                dateFormat:'Y-m-d'}} 
                                              className={`col-md-12 m-0 ${styles.contentBookingDate} webkit-appearance`} 
                                              placeholder={t('booking.date_out')} 
                                              onChange={(dates) =>{
                                                setEndDateLastYear(dayjs(dates[0]).format("YYYY-MM-DD"));
                                              }} />
                            
                              </div> 
                           </div>
                      </div>
                      <div 
                      style={{background: "#482979",borderRadius: 12, color: '#fff', height: 100, width: 100, fontSize: 16, fontWeight: 'bold', textAlign: 'center', lineHeight: '100px', cursor: 'pointer'}}
                      onClick={() => {
                                  if(startDateLastYear && endDateLastYear){
                                    fetchAdsDataLastYear()
                                    fetchAdsConversionDataLastYear()
                                  }}}
                        >
                        Get Data
                        </div>
                        </div>

                  <div style={{ display: "flex", flexDirection: "column", gap: 14 }} >
                    {[
                      {
                        label: "Conversion",
                        value: Intl.NumberFormat("de-DE", {maximumFractionDigits: 0}).format(conversionLastYear)
                      },
                      {
                        label: "Impressions",
                        value: Intl.NumberFormat("de-DE").format(impressionsLastYear)
                      },
                      {
                        label: "Clicks",
                        value: Intl.NumberFormat("de-DE").format(clicksLastYear)
                      },
                      {
                        label: "Cost",
                        value: Intl.NumberFormat("de-DE", { style: "currency", currency: currency }).format(CurrencyConverter(costsLastYear, currency, usdRate))},
                      {
                        label: "CTR",
                        value: Intl.NumberFormat("de-DE", { style: "percent", minimumFractionDigits: 2 }).format(ctrLastYear / 100)},
                      {
                        label: "CPC",
                        value: Intl.NumberFormat("de-DE", { style: "currency", currency: currency }).format(CurrencyConverter(cpcLastYear , currency, usdRate ) )},
                      {
                        label: "CVR",
                        value: Intl.NumberFormat("de-DE", { style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( clicksLastYear > 0 ? (conversionLastYear / clicksLastYear) : 0 )},
                      {
                        label: "CPA",
                        value: Intl.NumberFormat("de-DE", { style: "currency", currency: currency, maximumFractionDigits: 0 }).format( conversionLastYear > 0 ? costsLastYear / conversionLastYear : 0 ) }
                    ].map((item, index) => (
                      <div key={index} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: 10, borderBottom: "1px solid #f1f1f1" }} >
                        <div style={{ color: "#777", fontSize: 25 }} > {item.label} </div>
                        <div style={{ fontWeight: "bold", fontSize: 30, color: "#222" }} >
                          {item.value}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div style={{marginTop: 10, fontSize: 30, fontWeight: 'bold'}}>{dayjs(startDateLastYear).format("MMM-YYYY")}</div>
                </div>
              </div>
            </div>
          </div>
 {/* <div className="container-fluid pl-5 pr-5">
      <div className='row'>
        <div className={`col-md-3 p-3 ${styles.kpiCol}`}>
          <div className={styles.cardWrapper} data-tip={t('marketing.googleAds.impression')} data-for="marketing">
                          <StatCard
                            height={320}
                            fontTitle={40}
                            fontValue={60}
                            title="IMPRESSIONS"
                            value={Intl.NumberFormat('de-DE').format(impressions)}
                            icon={<Monitor size={30} color="#4b0082" />}
                            gradientFrom="#4b0082"
                            gradientTo="#8a2be2"
                          />
                    </div>
        </div>
          <div className={`col-md-3 p-3 ${styles.kpiCol}`} >
           <div className={styles.cardWrapper}  data-tip={t('marketing.googleAds.click')} data-for="marketing">
                          <StatCard
                            height={320}
                            fontTitle={40}                            
                            fontValue={60}
                            title="CLICKS"
                            value={Intl.NumberFormat('de-DE').format(clicks)}
                            icon={<Mouse size={30} color="#4b0082" />}
                            gradientFrom="#4b0082"
                            gradientTo="#8a2be2"
                          />
                    </div>
        </div>
           <div className={`col-md-3 p-3 ${styles.kpiCol}`}>
           <div className={styles.cardWrapper}  data-tip={t('marketing.googleAds.conversion')} data-for="marketing">
                          <StatCard
                            height={320}
                            fontTitle={40}
                            fontValue={60}
                            title="CONVERSIONS"
                            value={Intl.NumberFormat("de-DE", { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(Math.round(conversion))}
                            icon={<ConciergeBell size={30} color="#4b0082" />}
                            gradientFrom="#4b0082"
                            gradientTo="#8a2be2"
                          />
                    </div>
        </div>
           <div className={`col-md-3 p-3 ${styles.kpiCol}`}>
           <div className={styles.cardWrapper}  data-tip={t('marketing.googleAds.cost')} data-for="marketing">
                          <StatCard
                            unit="đ"
                            height={320}
                            fontTitle={40}
                            fontValue={60}
                            title="COST"
                            value={Intl.NumberFormat("de-DE", { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(costs)}
                            icon={<Banknote size={30} color="#4b0082" />}
                            gradientFrom="#4b0082"
                            gradientTo="#8a2be2"
                          />
                    </div>
        </div>
        </div>
         <div className='row'>
           <div className={`col-md-3 p-3 ${styles.kpiCol}`}>
           <div className={styles.cardWrapper}  data-tip={t('marketing.googleAds.ctr')} data-for="marketing">
                          <StatCard
                            unit="%"
                            height={320}
                            fontTitle={40}
                            fontValue={60}
                            title="CTR"
                            value={Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(ctr)}
                            icon={<Calculator size={30} color="#4b0082" />}
                            gradientFrom="#4b0082"
                            gradientTo="#8a2be2"
                          />
                    </div>
        </div>
           <div className={`col-md-3 p-3 ${styles.kpiCol}`}>
           <div className={styles.cardWrapper}  data-tip={t('marketing.googleAds.cpc')} data-for="marketing">
                          <StatCard
                            unit="đ"
                            height={320}
                            fontTitle={40}
                            fontValue={60}
                            title="CPC"
                            value={Intl.NumberFormat("de-DE", { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(cpc)}
                            icon={<Calculator size={30} color="#4b0082" />}
                            gradientFrom="#4b0082"
                            gradientTo="#8a2be2"
                          />
                    </div>
        </div>
           <div className={`col-md-3 p-3 ${styles.kpiCol}`}>
           <div className={styles.cardWrapper}  data-tip={t('marketing.googleAds.cvr')} data-for="marketing">
                          <StatCard
                            unit="%"
                            height={320}
                            fontTitle={40}
                            fontValue={60}
                            title="CVR"
                            value={Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(clicks > 0 ? (conversion / clicks) *100 : 0)}
                            icon={<ConciergeBellIcon size={30} color="#4b0082" />}
                            gradientFrom="#4b0082"
                            gradientTo="#8a2be2"
                          />
                    </div>
        </div>
           <div className={`col-md-3 p-3 ${styles.kpiCol}`}>
         <div className={styles.cardWrapper}  data-tip={t('marketing.googleAds.cpa')} data-for="marketing">
                          <StatCard
                            unit="đ"
                            height={320}
                            fontTitle={40}
                            fontValue={60}
                            title="CPA"
                            value={Intl.NumberFormat("de-DE", { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(conversion > 0 ? costs / conversion : 0)}
                            icon={<Calculator size={30} color="#4b0082" />}
                            gradientFrom="#4b0082"
                            gradientTo="#8a2be2"
                          />
                    </div>
        </div>
            
      </div>
      <ReactTooltip id = 'marketing' style={{
          fontSize: 20,
          maxWidth: 400,
          whiteSpace: "pre-line",
          backgroundColor: "#000",
          borderRadius: 10,
          zIndex: 99999
        }}/>
    </div> */}
      </>

  );
}



